var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.price >= 5000)?_c('div',{staticClass:"affirm-as-low-as text-gray-dark text-sm font-normal py-2",class:{ 'text-center': _vm.alignment === 'center', 'text-left': _vm.alignment === 'left' },attrs:{"data-page-type":_vm.pageType,"data-amount":_vm.price}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }